import { PREFER_NOT_TO_USE_TITLE } from "@albertine/types";
import { useState } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import {
    getTitleSelectValue,
    PREDEFINED_TITLES,
    TITLE_SELECT_OPTIONS,
} from "@/utils/title.util";
import { FormField, FormInput } from "../../form-field/FormField";

const TITLE_OPTIONS = [
    { id: TITLE_SELECT_OPTIONS.EMPTY, label: "Not set" },
    ...PREDEFINED_TITLES.map((title) => ({ id: title, label: title })),
    {
        id: TITLE_SELECT_OPTIONS.PREFER_NOT_TO_USE,
        label: TITLE_SELECT_OPTIONS.PREFER_NOT_TO_USE,
    },
    { id: TITLE_SELECT_OPTIONS.OTHER, label: TITLE_SELECT_OPTIONS.OTHER },
];

export function TitleField({
    id,
    value,
    onChange,
}: {
    id: string;
    value: string;
    onChange: (value: string) => void;
}) {
    const initialSelectValue = getTitleSelectValue(value);
    const [selectValue, setSelectValue] = useState(initialSelectValue);
    const [customTitle, setCustomTitle] = useState(
        initialSelectValue === TITLE_SELECT_OPTIONS.OTHER ? value : "",
    );

    function handleSelectChange(next: string | null) {
        if (next === null) return;

        setSelectValue(next);

        if (next === TITLE_SELECT_OPTIONS.OTHER) {
            onChange(customTitle);
            return;
        }

        setCustomTitle("");

        if (next === TITLE_SELECT_OPTIONS.EMPTY) {
            onChange("");
            return;
        }

        if (next === TITLE_SELECT_OPTIONS.PREFER_NOT_TO_USE) {
            onChange(PREFER_NOT_TO_USE_TITLE);
            return;
        }

        onChange(next);
    }

    return (
        <FormField label="Title">
            <Select
                items={Object.fromEntries(
                    TITLE_OPTIONS.map((option) => [option.id, option.label]),
                )}
                value={selectValue}
                onValueChange={handleSelectChange}
            >
                <SelectTrigger id={id} className="w-full">
                    <SelectValue placeholder="Not set" />
                </SelectTrigger>
                <SelectContent>
                    {TITLE_OPTIONS.map((option) => (
                        <SelectItem key={option.id || "empty"} value={option.id}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {selectValue === TITLE_SELECT_OPTIONS.OTHER && (
                <FormInput
                    value={customTitle}
                    placeholder="Enter custom title"
                    onChange={(event) => {
                        const next = event.currentTarget.value;
                        setCustomTitle(next);
                        onChange(next);
                    }}
                />
            )}
        </FormField>
    );
}
